import stringUtils from "@/businesslogic/utils/stringUtils";

export default function adressUtils(): any {
  const { equals: stringEquals, empty: stringEmpty } = stringUtils();

  const equals = (a1: any, a2: any): boolean => {
    if (a1 && a2) {
      return (
        stringEquals(a1.plz, a2.plz) &&
        stringEquals(a1.ort, a2.ort) &&
        stringEquals(a1.strasse, a2.strasse) &&
        stringEquals(a1.hausnummer, a2.hausnummer)
      );
    }

    return a1 === a2;
  };

  const empty = (adresse: any): boolean => {
    return (
      adresse &&
      stringEmpty(adresse.plz) &&
      stringEmpty(adresse.ort) &&
      stringEmpty(adresse.strasse) &&
      stringEmpty(adresse.hausnummer)
    );
  };
  return {
    equals,
    empty,
  };
}
